import Api from './index'
import store from '@/store'

export default {
  // Jeden endpoint dla zalogowanych i gości - token tylko gdy user jest zalogowany
  // (pusty "Bearer null" backend odrzuciłby jako nieprawidłowy token)
  async chat(data) {
    const token = store.getters['appkonspektypilkanozna/myToken'];
    return Api().post('jose/chat/', data, token ? {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    } : {})
  },
  async listChatHistory(type, search, pagination) {
    let page = '';
    if (pagination) {
      const url = new URL(pagination);
      page= url.search
    }
    return Api().get(`jose/chat/history/?type=${type}&search=${search}&${page}`, {
      headers: {
          'Authorization': `Bearer ${store.getters['appkonspektypilkanozna/myToken']}`,
      }
    })
  },
}

